/** Device orientation manager. */
export class DeviceOrientationManager {

	/**
	 * Registers a change in the orientation of the device.
	 * @param onResize Resize handler.
	 */
	public static registerDeviceOrientationChange(onResize: () => void): void {
		// Listen for orientation changes directly
		window.addEventListener('orientationchange', () => {
			// Add a small delay to allow the viewport to adjust
			setTimeout(() => {
				onResize();
			}, 100);
		});

		// Also listen for window resize as a fallback
		window.addEventListener('resize', onResize);
	}

}
